/**
 * Product Media Gallery Dots
 * Updates active dot indicator based on scroll position
 */
document.addEventListener('DOMContentLoaded', function() {
  const mediaGallery = document.querySelector('.product__media-gallery');
  if (!mediaGallery) return;

  const dots = mediaGallery.querySelectorAll('.slider-dot');
  const slides = mediaGallery.querySelectorAll('.product__media-item');
  
  if (dots.length === 0) return;

  // Update dots when scrolling
  const updateActiveDot = () => {
    const galleryWidth = mediaGallery.offsetWidth;
    const scrollPosition = mediaGallery.scrollLeft;
    const activeIndex = Math.round(scrollPosition / galleryWidth);
    
    dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.classList.remove('is-active');
        dot.removeAttribute('aria-current');
      }
    });
  };

  // Add scroll event listener
  mediaGallery.addEventListener('scroll', updateActiveDot);
  
  // Initial update
  updateActiveDot();
});

